import React from 'react';


const LoaderPage: React.FC = () => {
  return (
    <div className="loader-container-page">
      <span className="loader">AskWellie.</span>
    </div>
  );
};


export default LoaderPage;
